var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup10000024571(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.630371,
    y: 0.635742,
    width: 41.9141,
    height: 41.9141,
    rx: 6.44833,
    fill: "#D7D7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1352_1089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8721 18.7729V13.8879C32.8721 12.6994 31.9075 11.7348 30.719 11.7348H30.5461V10.2569C30.5461 9.93112 30.2785 9.66357 29.9527 9.66357H29.1137C28.7879 9.66357 28.5203 9.93112 28.5203 10.2569V11.7348H25.4627V10.5645C25.4627 10.0694 25.0076 9.66357 24.4507 9.66357C23.8938 9.66357 23.4388 10.0694 23.4388 10.5645V11.7348H20.3811V10.5645C20.3811 10.0694 19.9261 9.66357 19.3691 9.66357C18.8122 9.66357 18.3554 10.0694 18.3554 10.5645V11.7348H15.2977V10.2569C15.2977 9.93112 15.0301 9.66357 14.7043 9.66357H13.8653C13.5395 9.66357 13.272 9.93112 13.272 10.2569V11.7348H13.0991C11.9124 11.7348 10.9478 12.6976 10.9478 13.8879V18.7729V31.4241C10.9478 32.6126 11.9124 33.5772 13.1009 33.5772H30.719C31.9075 33.5772 32.8721 32.6126 32.8721 31.4241V18.7729Z",
    fill: "url(#paint0_linear_1352_1089)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1352_1089",
    x1: 29.3255,
    y1: 15.1447,
    x2: 18.6858,
    y2: 33.5224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC95DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#873FB2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1352_1089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.9243,
    height: 23.9136,
    fill: "white",
    transform: "translate(10.9478 9.66309)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup10000024571);
export default __webpack_public_path__ + "static/media/Group-1000002457-1.e3e5702383a84944b9e68435672796ca.svg";
export { ForwardRef as ReactComponent };